module.exports = __webpack_public_path__ + "img/Groupe 76.16a3487b.svg";